import React, { useState } from 'react';
import ForgetPasswordForm from './forms/ForgetPasswordForm';
import { toast } from 'react-toastify';
import { authHelpers } from 'lib/supabase';

const ForgetPassword = () => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async ({ email }) => {
    setLoading(true);
    try {
      const { error } = await authHelpers.resetPassword(email);

      if (error) {
        if (error.message.includes('not found')) {
          toast.error('Email does not exist');
        } else {
          toast.error(error.message);
        }
      } else {
        toast.success('Password reset email sent! Check your inbox.');
      }
    } catch (error) {
      console.error('Password reset error:', error);
      toast.error('Something went wrong! Please try again');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="text-center">
      <h5 className="mb-0"> Forgot your password?</h5>
      <small>Enter your email and we'll send you a reset link.</small>
      <ForgetPasswordForm onSubmit={onSubmit} loading={loading} />
    </div>
  );
};

export default ForgetPassword;
